import { render, staticRenderFns } from "./loginSuccessTest.vue?vue&type=template&id=63e96606&scoped=true&"
import script from "./loginSuccessTest.vue?vue&type=script&lang=js&"
export * from "./loginSuccessTest.vue?vue&type=script&lang=js&"
import style0 from "./loginSuccessTest.vue?vue&type=style&index=0&id=63e96606&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e96606",
  null
  
)

export default component.exports